import {
  ActionType,
  TableColumn,
} from "../../../../Component/Model/Table/Table";
import { EEPlanObjective } from "../../../../Component/Model/Dto/EmploymentEquity/Plan/EEObjective";
import {
  DataTableHtmlFormatter,
  TableDateHelper,
} from "../../../../Component/Model/helpers";
import { DefaultCell } from "../../../../Component/Common/Components/DataTable/DefaultCell";
import { ActionsCellWithBadge } from "../../../../Component/Common/Components/DataTable/ActionsCellWithBadge";
import { ActionsCell } from "../../../../Component/Common/Components/DataTable/ActionsCell";

interface ObjectivesRow {
  Id: string;
  Year: string;
  Description: string;
  SupportingDocuments: any;
  SourceScorecard: React.ReactNode;
  Actions?: ActionType[];
}

interface ObjectivesTable {
  columns: Array<TableColumn>;
  rows: Array<ObjectivesRow>;
}

export function EEPlanObjectivesTableMapper(
  dataObject: EEPlanObjective.DtoIn[],
  handleEdit: (id: string) => void,
  handleDelete: (id: string) => void,
  handleAttachedSD: (id: string) => void,
  isConsolidated: boolean
): ObjectivesTable {
  const columns = [
    {
      Header: "Year",
      accessor: "Year",
      id: "EEObjectiveYearId",
      Cell: ({ value }: any) => <DefaultCell value={value} />,
    },
    {
      Header: "Description",
      accessor: "Description",
      Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} />,
    },
    {
      Header: "Supporting Documents",
      accessor: "SupportingDocuments",
      Cell: ({ value }: any) => (
        <ActionsCellWithBadge actions={value} key={value} />
      ),
      disableSortBy: true,
    },
    {
      Header: "Actions",
      accessor: "Actions",
      Cell: ({ value }: any) => <ActionsCell actions={value} />,
      disableSortBy: true,
    },
  ];

  if (isConsolidated) {
    columns.splice(3, 0, {
      Header: "Source Scorecard",
      accessor: "SourceScorecard",
      Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} />,
      disableSortBy: true,
    });
  }

  if (dataObject !== undefined && dataObject.length > 0) {
    const rows = dataObject.map((item: EEPlanObjective.DtoIn) => ({
      Id: item.id,
      Year: `Year ${item.yearId}: ${TableDateHelper(
        item.yearStart
      )} - ${TableDateHelper(item.yearEnd)}`,
      Description: DataTableHtmlFormatter(item.description, " "),
      SupportingDocuments: item.documentsSelectedForDownload
        ? [
            {
              label: `${item.documentCount} Supporting Document(s)`,
              action: handleAttachedSD,
              key: item.id,
              icon: { color: "info", name: "attach_file" },
              badgeCount: item.documentCount,
            },
            // { label: 'Remove Documents from Download Pack', action: handleToggleDocumentPack, key: item.id, icon: { color: 'secondary', name: 'bookmark_remove' } }
          ]
        : [
            {
              label: `${item.documentCount} Supporting Document(s)`,
              action: handleAttachedSD,
              key: item.id,
              icon: { color: "info", name: "attach_file" },
              badgeCount: item.documentCount,
            },
            // { label: 'Add Documents to Download Pack', action: handleToggleDocumentPack, key: item.id, icon: { color: 'secondary', name: 'bookmark_add' } },
          ],
      SourceScorecard: item.sourceScorecardName ?? <i>None</i>,
      Actions: [
        {
          label: "View/Edit",
          action: handleEdit,
          key: item.id,
          icon: { color: "info", name: "edit" },
        },
        {
          label: "Delete",
          action: handleDelete,
          key: item.id,
          icon: { color: "error", name: "delete" },
        },
      ],
    }));

    return { columns: columns, rows: rows };
  } else {
    return { columns: columns, rows: [] };
  }
}
